module.exports = __webpack_public_path__ + "static/11-45dd6491502626691863ec9220e609d1.png";